// List cards use Supabase image render so covers stay small. Ultra-high-res
// source art (10k–20k px) can 400 from the transform API — callers must use
// blank/placeholder then, never the raw original (that freezes Chrome).
// Oversized DB files should be replaced with compressed uploads (≤5MB, ≤2k px).
//
// Card cover area is 16:9 (paddingTop: 9/16). Avatar is 48px (use 2x for retina).
export const THUMB_SIZES = {
  cover: { width: 640, height: 360, quality: 65 },
  profile: { width: 96, height: 96, quality: 70 },
};

export function getOptimizedThumbnail(url, size = 'cover') {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('/storage/v1/object/public/')) return url;

  const preset = typeof size === 'string' ? THUMB_SIZES[size] : null;
  const width = preset?.width ?? (typeof size === 'number' ? size : THUMB_SIZES.cover.width);
  const height = preset?.height;
  const quality = preset?.quality ?? 65;

  const transformedUrl = url.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
  const separator = transformedUrl.includes('?') ? '&' : '?';
  const heightParam = height ? `&height=${height}` : '';
  // resize=cover fills the box (matches CSS object-fit: cover) — avoids side letterboxing
  return `${transformedUrl}${separator}width=${width}${heightParam}&quality=${quality}&resize=cover`;
}
